import { c as _c } from "react/compiler-runtime";
import { useViewPort } from "@website/hooks/viewport";
import { Button } from "@website/ui/button";
import { Header, Input, Main } from "@website/ui/datepicker/components";
import { FlatHeader } from "@website/ui/datepicker/components/flat-header/flat-header";
import styles from "@website/ui/datepicker/datepicker.module.scss";
import { DatepickerPropertiesType } from "@website/ui/datepicker/datepicker.types";
import { useCalendarLocale, usePopover, useScroll, useShowDate } from "@website/ui/datepicker/hooks";
import { PopoverFull } from "@website/ui/popover-full";
import { FC } from "react";
export const Datepicker: FC<DatepickerPropertiesType> = properties => {
  const $ = _c(66);
  const {
    id,
    acceptEmpty: t0,
    type: t1,
    error,
    fullWidth,
    helperText,
    mode,
    setMode,
    onChange,
    fromTitle,
    toTitle,
    value,
    setValue,
    changeableMode,
    calendarData,
    size,
    position,
    gapHorizontal,
    gapVertical,
    disableLimit,
    view: t2,
    suggestions,
    noBorder,
    inputClassName,
    hideMiddleLine,
    hasDropdownIcon,
    labelClassName,
    disableDates,
    isLabelTop,
    initialOpen,
    ctaAcceptClick,
    ctaCancelClick,
    backButton,
    footerContent
  } = properties;
  const acceptEmpty = t0 === undefined ? false : t0;
  const type = t1 === undefined ? "popover" : t1;
  const view = t2 === undefined ? "default" : t2;
  const isRejectable = acceptEmpty && Boolean(ctaCancelClick);
  let t3;
  if ($[0] !== initialOpen) {
    t3 = {
      initialOpen
    };
    $[0] = initialOpen;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const {
    onOpenPopover,
    onClosePopover,
    popoverProperties
  } = usePopover(t3);
  const {
    scrollReference,
    setScrollReference,
    scrolled,
    scrollToTop
  } = useScroll();
  const disableCta = mode === "single" && value.length === 0 || mode !== "single" && Boolean(acceptEmpty) !== true && value.length <= 1;
  const {
    calendarLocale,
    changeCalendarLocaleToGregorian,
    changeCalendarLocaleToPersian
  } = useCalendarLocale(properties);
  const {
    isDesktop,
    isMobile
  } = useViewPort();
  const {
    onNextMonthClick,
    onPreviousMonthClick,
    onShowTodayClick,
    showDates,
    increaseShowDatesNumber,
    nextMonthDisabled,
    previousMonthDisabled
  } = useShowDate(calendarLocale, scrollToTop, value, view);
  let t4;
  if ($[2] !== ctaAcceptClick || $[3] !== onClosePopover) {
    t4 = function onAccept() {
      onClosePopover();
      ctaAcceptClick?.();
    };
    $[2] = ctaAcceptClick;
    $[3] = onClosePopover;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const onAccept = t4;
  let t5;
  if ($[5] !== acceptEmpty || $[6] !== calendarLocale || $[7] !== ctaCancelClick || $[8] !== onChange || $[9] !== value?.length) {
    t5 = function onClean() {
      onChange([], calendarLocale);
      if (acceptEmpty) {
        if (value?.length !== 2) {
          ctaCancelClick?.();
        }
      } else {
        ctaCancelClick?.();
      }
    };
    $[5] = acceptEmpty;
    $[6] = calendarLocale;
    $[7] = ctaCancelClick;
    $[8] = onChange;
    $[9] = value?.length;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const onClean = t5;
  let t6;
  if ($[11] !== acceptEmpty || $[12] !== backButton || $[13] !== calendarData || $[14] !== calendarLocale || $[15] !== changeCalendarLocaleToGregorian || $[16] !== changeCalendarLocaleToPersian || $[17] !== changeableMode || $[18] !== disableCta || $[19] !== disableDates || $[20] !== disableLimit || $[21] !== error || $[22] !== footerContent || $[23] !== fromTitle || $[24] !== fullWidth || $[25] !== gapHorizontal || $[26] !== gapVertical || $[27] !== hasDropdownIcon || $[28] !== helperText || $[29] !== hideMiddleLine || $[30] !== id || $[31] !== increaseShowDatesNumber || $[32] !== inputClassName || $[33] !== isDesktop || $[34] !== isLabelTop || $[35] !== isMobile || $[36] !== isRejectable || $[37] !== labelClassName || $[38] !== mode || $[39] !== nextMonthDisabled || $[40] !== noBorder || $[41] !== onAccept || $[42] !== onChange || $[43] !== onClean || $[44] !== onClosePopover || $[45] !== onNextMonthClick || $[46] !== onOpenPopover || $[47] !== onPreviousMonthClick || $[48] !== onShowTodayClick || $[49] !== popoverProperties || $[50] !== position || $[51] !== previousMonthDisabled || $[52] !== properties.value?.length || $[53] !== scrollReference || $[54] !== scrolled || $[55] !== setMode || $[56] !== setScrollReference || $[57] !== setValue || $[58] !== showDates || $[59] !== size || $[60] !== suggestions || $[61] !== toTitle || $[62] !== type || $[63] !== value || $[64] !== view) {
    t6 = <div className={`${styles.datepicker} ${styles.rtl}`}>{type === "flat" ? <><FlatHeader calendarLocale={calendarLocale} nextMonthDisabled={nextMonthDisabled} previousMonthDisabled={previousMonthDisabled} scrolled={scrolled} showDates={isDesktop && view !== "mobile" ? showDates : [showDates[0]]} showNextMonth={onNextMonthClick} showPreviousMonth={onPreviousMonthClick} type={type} view={view} /><Main calendarData={calendarData} calendarLocale={calendarLocale} disableDates={disableDates} disableLimit={disableLimit} increaseShowDatesNumber={increaseShowDatesNumber} mode={mode} onChange={onChange} scrollReference={scrollReference} setScrollReference={setScrollReference} setValue={setValue} showDates={isDesktop && view !== "mobile" ? showDates : [showDates[0]]} suggestions={suggestions} type={type} value={value} view={view} isLabelTop={isLabelTop} /></> : <><Input calendarLocale={calendarLocale} changeableMode={changeableMode} data-testid="date_picker_input" error={error} fromTitle={fromTitle} fullWidth={fullWidth} hasDropdownIcon={hasDropdownIcon} helperText={helperText} hideMiddleLine={hideMiddleLine} inputClassName={inputClassName} labelClassName={labelClassName} mode={mode} noBorder={noBorder} onOpenPopover={onOpenPopover} setMode={setMode} size={size} toTitle={toTitle} value={value} id={id} /><PopoverFull {...popoverProperties} gapHorizontal={isDesktop && view !== "mobile" ? gapHorizontal ?? popoverProperties.gapHorizontal : "0px"} gapVertical={isDesktop && view !== "mobile" ? gapVertical ?? popoverProperties.gapVertical : "0px"} position={position ?? popoverProperties.position}><div className={styles.popover}><Header backButton={backButton} calendarLocale={calendarLocale} changeCalendarLocale={calendarLocale === "persian" ? changeCalendarLocaleToGregorian : changeCalendarLocaleToPersian} inputProperties={{
              fromTitle,
              toTitle,
              mode,
              setMode,
              value,
              calendarLocale,
              changeableMode
            }} nextMonthDisabled={nextMonthDisabled} onClose={onClosePopover} previousMonthDisabled={previousMonthDisabled} scrolled={scrolled} showDates={showDates} showNextMonth={onNextMonthClick} showPreviousMonth={onPreviousMonthClick} showToday={onShowTodayClick} type={type} view={view} /><Main calendarData={calendarData} calendarLocale={calendarLocale} disableDates={disableDates} disableLimit={disableLimit} increaseShowDatesNumber={increaseShowDatesNumber} mode={mode} onChange={onChange} scrollReference={scrollReference} setScrollReference={setScrollReference} setValue={setValue} showDates={showDates} suggestions={suggestions} type={type} value={value} view={view} isLabelTop={isLabelTop} /><div className="border-t-outline-thin flex w-full items-center justify-end border-t px-6 pb-6 pt-4 max-md:flex-col">{footerContent}<div className="flex justify-end gap-4 max-md:w-full"><Button onClick={onClean} color="secondary" size="large" variant={isMobile && footerContent ? "outline" : "text"} fullWidth={isMobile || view === "mobile"} disabled={acceptEmpty ? !acceptEmpty : disableCta}>{isRejectable && properties?.value?.length !== 2 ? "\u0631\u062F \u06A9\u0631\u062F\u0646" : "\u067E\u0627\u06A9 \u06A9\u0631\u062F\u0646"}</Button><Button onClick={onAccept} color="secondary" size="large" variant="contained" fullWidth={isMobile || view === "mobile"} disabled={disableCta}>تایید</Button></div></div></div></PopoverFull></>}</div>;
    $[11] = acceptEmpty;
    $[12] = backButton;
    $[13] = calendarData;
    $[14] = calendarLocale;
    $[15] = changeCalendarLocaleToGregorian;
    $[16] = changeCalendarLocaleToPersian;
    $[17] = changeableMode;
    $[18] = disableCta;
    $[19] = disableDates;
    $[20] = disableLimit;
    $[21] = error;
    $[22] = footerContent;
    $[23] = fromTitle;
    $[24] = fullWidth;
    $[25] = gapHorizontal;
    $[26] = gapVertical;
    $[27] = hasDropdownIcon;
    $[28] = helperText;
    $[29] = hideMiddleLine;
    $[30] = id;
    $[31] = increaseShowDatesNumber;
    $[32] = inputClassName;
    $[33] = isDesktop;
    $[34] = isLabelTop;
    $[35] = isMobile;
    $[36] = isRejectable;
    $[37] = labelClassName;
    $[38] = mode;
    $[39] = nextMonthDisabled;
    $[40] = noBorder;
    $[41] = onAccept;
    $[42] = onChange;
    $[43] = onClean;
    $[44] = onClosePopover;
    $[45] = onNextMonthClick;
    $[46] = onOpenPopover;
    $[47] = onPreviousMonthClick;
    $[48] = onShowTodayClick;
    $[49] = popoverProperties;
    $[50] = position;
    $[51] = previousMonthDisabled;
    $[52] = properties.value?.length;
    $[53] = scrollReference;
    $[54] = scrolled;
    $[55] = setMode;
    $[56] = setScrollReference;
    $[57] = setValue;
    $[58] = showDates;
    $[59] = size;
    $[60] = suggestions;
    $[61] = toTitle;
    $[62] = type;
    $[63] = value;
    $[64] = view;
    $[65] = t6;
  } else {
    t6 = $[65];
  }
  return t6;
};